import { get } from 'lodash';
import moment from 'moment-timezone';

import AuthUser from './AuthUser';

export const getStoreLocalTime = () => {
  const loggedInUser = AuthUser.getAuthUser();
  const store = loggedInUser.store;
  const clientTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const myTime = moment().tz(get(store, 'timezoneIdentifier.identifier'));
  const sameTimeDifferentZone = moment.tz(
    myTime.format('YYYY-MM-DDTHH:mm:ss.SSS'),
    moment.ISO_8601,
    clientTz
  );
  return sameTimeDifferentZone.toDate();
};

export const convertToStoreLocalTime = (
  utcTime,
  format = 'MM/DD/YY, hh:mm A'
) => {
  const loggedInUser = AuthUser.getAuthUser();
  const store = loggedInUser.store;
  const tz = get(store, 'timezoneIdentifier.identifier');

  return moment.utc(utcTime).tz(tz).format(format);
};

export const convertFromStoreLocalTime = (
  time: string,
  format = null
): number | string => {
  if (time === null) {
    return null;
  }
  const loggedInUser = AuthUser.getAuthUser();
  const store = loggedInUser.store;
  const tz = get(store, 'timezoneIdentifier.identifier');
  if (format) {
    const m = moment(time);
    const k = m.tz(tz, true);
    const v = k.format(format);
    return v;
  } else {
    return moment(time).tz(tz, true).valueOf();
  }
};

export const isDateToday = (date: Date, compareDate: Date = new Date()) => {
  return (
    date.getUTCDate() === compareDate.getUTCDate() &&
    date.getUTCMonth() === compareDate.getUTCMonth()
  );
};

export const roundToNearestTimeBlock = (date, duration, method) => {
  duration = duration || moment.duration(15, 'minutes');
  method = method || 'floor';
  return moment(Math[method](+date / +duration) * +duration);
};

export const getNowEpoch = () => {
  const loggedInUser = AuthUser.getAuthUser();
  const store = loggedInUser?.store;
  const storeTz = get(store, 'timezoneIdentifier.identifier');
  return moment().tz(storeTz);
};
